import HttpClient from '@/common/boot/HttpClient'

const listarUsuarios = async ({commit}) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/usuarios`).then(response => {
    commit('INSERIR_LISTA_USUARIOS', response.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const recuperarPerfilComUsuarios = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/roles/${payload}/usuarios`, payload).then(response => {
    commit('INSERIR_PERFIL_SELECIONADO', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

const associarUsuariosAoPerfil = ({ commit }, payload) => {
  console.log(payload);

  commit('BUSCANDO', true);

  HttpClient.post(`/roles/${payload.perfilId}/usuarios/sincronizar`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

export {
  listarUsuarios,
  recuperarPerfilComUsuarios,
  associarUsuariosAoPerfil
}